// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCountStyles } from "@awc/Overrides/Widgets/ProductList/ProductListProductCount";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@awc/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const sharedTextStyles: TypographyPresentationProps = {
    color: "primary",
    variant: "h5",
    forwardAs: "p",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
        .count-text {
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};

productCountStyles.wrapper = {
    css: css`
        display: flex;
        gap: 12px 32px;
        margin-bottom: 16px;
        align-items: baseline;
        flex-wrap: wrap;
    `,
};

productCountStyles.textWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 8px;
    `,
};

productCountStyles.resultsForText = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            &:after {
                content: ":";
            }
        `,
    }),
};

productCountStyles.countText = {
    ...sharedTextStyles,
};

productCountStyles.queryText = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};
